<ng-container *ngIf="devicesStore.isV2Cascade$ | async; else defaultInstallation">
  <app-control-units
    *ngFor="let device of devicesStore.devicesOfV2Cascade$ | async; trackBy: trackBy"
    [cascadeDevice]="device"
    [showExternalCANAddress]="
      (deviceProductMatrix$ | async)?.properties?.product?.value?.length > 1
    "
  ></app-control-units>
</ng-container>

<ng-template #defaultInstallation>
  <app-control-units></app-control-units>
</ng-template>
